/**
 * 나 탭의 알림 받기 (DEV_SPEC 4.8, 시안 03 M1). 서버와 클라이언트가 함께 쓰는 단일 원본입니다.
 *
 * 매일 콘텐츠 4개(config/daily) + 고민 후속(고른 지 7일 뒤 질문) + 별채 부르기(지목·편 가르기 푸시).
 * kind 는 notification_prefs.kind 의 값입니다. 행이 없으면 defaultOn 을 따릅니다.
 * 기본값: 운세·한 문장·체크인·고민 후속·별채 부르기 켜짐, 오늘의 한 수 꺼짐.
 */
import { DAILY_KINDS } from '../daily/index.js';

export const NOTIFICATION_KINDS = [
    { kind: 'fortune', name: DAILY_KINDS.fortune.name, defaultOn: true },
    { kind: 'sentence', name: DAILY_KINDS.sentence.name, defaultOn: true },
    { kind: 'daily_move', name: DAILY_KINDS.daily_move.name, defaultOn: false },
    { kind: 'checkin', name: DAILY_KINDS.checkin.name, defaultOn: true },
    { kind: 'worry_followup', name: '고민 후속', defaultOn: true },
    { kind: 'room_hook', name: '별채 부르기', defaultOn: true },
];

export const NOTIFICATION_KIND_KEYS = NOTIFICATION_KINDS.map((item) => item.kind);
